import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import AsyncCreatableSelect from 'react-select/async-creatable';

import CreateConsignmentContainer from '@containers/consignment/crud/CreateConsignmentContainer';

import { search } from '@api/consignmentApi';

import * as consignmentActions from '@actions/consignmentActions';
import * as navigationActions from '@actions/navigationActions';

let searchTimeout = null;

export const transformConsignmentToValue = (consignment) => ({
  value: consignment.id,
  label: consignment.name,
  consignment: consignment,
});

class ConsignmentInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      consignment: this.props.consignment
        ? this.props.isMulti
          ? this.props.consignment.length > 0
            ? this.props.consignment.map((consignment) => transformConsignmentToValue(consignment))
            : []
          : transformConsignmentToValue(this.props.consignment)
        : null,
      consignments: [],
    };
  }

  componentDidMount() {
    const { consignment, getConsignment, consignmentId, isMulti, consignmentOptions } = this.props;

    if (!isMulti) {
      if (!consignment && consignmentId) {
        getConsignment(consignmentId).then((response) => {
          if (response.success) {
            this.setState({ consignment: transformConsignmentToValue(response.consignment) });
          }
        });
      }
      search({}, 0, 40).then((response) => {
        this.setState({
          consignments: response.consignments,
        });
      });
    } else if (isMulti && consignmentOptions) {
      this.setState({ consignments: consignmentOptions });
    }
  }

  onChange = (newConsignment) => {
    const { isMulti, onChange } = this.props;

    if (!isMulti) {
      this.setState({ consignment: newConsignment });
      onChange?.(newConsignment ? newConsignment.consignment : null);
    } else {
      this.setState({ consignment: newConsignment });
      onChange?.(newConsignment);
    }
  };

  render() {
    const { t, isFetchingConsignments, addToStack, placeholder, isMulti } = this.props;
    const { consignment, consignments } = this.state;

    return (
      <div className="input-group no-margin-top">
        <AsyncCreatableSelect
          isMulti={isMulti ? isMulti : false}
          isClearable
          cacheOptions
          defaultOptions={consignments.map((consignment) =>
            transformConsignmentToValue(consignment)
          )}
          placeholder={placeholder ? placeholder : `${t('form.label.searchConsignments')}`}
          noOptionsMessage={() => t('form.startTyping')}
          formatCreateLabel={(inputValue) => t('form.addCreatable', { value: inputValue })}
          isLoading={isFetchingConsignments}
          isDisabled={isFetchingConsignments}
          loadOptions={(inputValue, callback) => {
            if (searchTimeout) clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
              search({ query: inputValue }, 0, 40).then((response) => {
                callback(
                  response.consignments.map((consignment) =>
                    transformConsignmentToValue(consignment)
                  )
                );
              });
            }, 800);
          }}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
          onChange={(e) => {
            this.onChange(e);
          }}
          onCreateOption={(inputValue) => {
            addToStack({
              name: t('consignment.new'),
              component: (
                <CreateConsignmentContainer
                  targetName={inputValue}
                  callback={(newConsignment) => {
                    this.onChange(transformConsignmentToValue(newConsignment));
                  }}
                />
              ),
            });
          }}
          value={consignment}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.auth.user,
    simpleForms: state.settings?.settings?.userInterface?.simpleForms,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getConsignment: (id) => dispatch(consignmentActions.getConsignment(id)),
    popStack: () => dispatch(navigationActions.popStack()),
    addToStack: (component) => dispatch(navigationActions.addToStack(component)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation('translation')(ConsignmentInput));
